<!--
10点57分
-->
<template>
  <!-- 卡片视图 -->
  <div class="card">
    <!-- 创建作业按钮 -->
    <el-button type="primary" class="new-project-btn" @click="createJob">
      {{ $t("jobManagementV2.newTest") }}
      <i class="el-icon-add"></i>
    </el-button>
    <!-- 表格数据展示 -->
    <el-table ref="tableList" :data="tableData" :header-cell-style="{
        height:'50px',
        padding:0,
       background: '#F3F7FE',
    color:' #566087',
    'font-weight': 'bold',
        }"  :cell-style="{
          padding:0,
          height:'48px'
        }" border height="calc(100% - 109px)" style="width: 100%" @sort-change="sortChange">
      <el-table-column :resizable='false' :label="$t('projectV2.index')" width="60" align="center">
        <template slot-scope="scope">
          <span v-text="getIndex(scope.$index)"> </span>
        </template>
      </el-table-column>
      <el-table-column :resizable='false' :label="$t('jobManagementV2.testName')" :show-overflow-tooltip="true" align="center" header-align='center' prop="projectName">
        <template slot-scope="scope">
          <span class="testdetail" @click="checkJob(scope.row)">{{scope.row.projectName}}</span>
        </template>
      </el-table-column>
      <el-table-column :resizable='false' :label="$t('projectV2.langDesc')" :show-overflow-tooltip="true" align="center" prop="langDesc">
        <template slot-scope="{ row }">
          <template v-if="$i18n.locale === 'zh'">{{row.langDesc.split('>')[0]}} —
            {{row.langDesc.split('>')[1]}}</template>
          <template v-else>{{$langCase[row.sourceLang]}} — {{$langCase[row.targetLang]}}</template>
        </template>
      </el-table-column>
      <el-table-column  :resizable='false' :label="$t('projectV2.domain')" align="center" prop="domainName">
        <template slot-scope="{ row }">
          {{
            $i18n.locale === "zh" ? row.domainName : $domainCase[row.domainCode]
          }}
        </template>
      </el-table-column>

      <el-table-column :resizable='false' :label="$t('projectV2.creator')" :show-overflow-tooltip="true" align="center" prop="creatorName"></el-table-column>
      <el-table-column :resizable='false' :label="$t('projectV2.createTime')" :show-overflow-tooltip="true" align="center" prop="createTime" sortable="custom"></el-table-column>
      <el-table-column  :resizable='false' :label="$t('projectV2.limitTime')" :show-overflow-tooltip="true" align="center" prop="limitTime" sortable="custom"></el-table-column>
      <el-table-column  :resizable='false' :label="$t('jobManagementV2.completion')" align="center">
        <template slot-scope="scope">
          <span :style="
              scope.row.finishTaskNumber === scope.row.totalTaskNumber &&
              scope.row.totalTaskNumber
                ? 'color:#0078FC'
                : ''
            ">
            {{ scope.row.finishTaskNumber }}/{{
              scope.row.totalTaskNumber
            }}</span>
        </template>
      </el-table-column>
      <el-table-column :resizable='false' width="211" :label="$t('projectV2.operation')" align="center" class-name="operation">
        <template slot-scope="scoped">

          <el-tooltip class="item check" effect="dark" :content="$t('projectV2.check')" placement="top">
            <span class="check" @click="checkJob(scoped.row)"></span>
          </el-tooltip>
          <el-tooltip class="item edit" effect="dark" :content="$t('jobManagementV2.editor')" placement="top">
            <span class="edit" @click="editJob(scoped.row)"></span>
          </el-tooltip>
          <el-tooltip class="item distribution" effect="dark" :content="$t('jobManagementV2.distribution')" placement="top">
            <span class="copy" @click="distribution(scoped.row)"></span>
          </el-tooltip>
          <el-tooltip class="item report" effect="dark" :content="$t('jobManagementV2.report')" v-show="scoped.row.totalTaskNumber > 0" placement="top">
            <span class="report" @click="reporte(scoped.row)"></span>
          </el-tooltip>
          <el-tooltip class="item delete" effect="dark" :content="$t('projectV2.delete')" placement="top">
            <span class="delete" @click="openDelDialog(scoped.row)"></span>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" :current-page="pageDto.page" @size-change="handleSizeChange" :page-sizes="[10, 20, 30, 40]" layout="prev, pager, next, sizes" :total="tableDataInfo.totalRows">
      </el-pagination>
    </div>
    <!-- 编辑弹窗 -->
    <edit-test></edit-test>
    <!-- 分配弹窗 -->
    <distribution-dialog :testLimitTime="testLimitTime"></distribution-dialog>

    <!-- 删除弹窗 -->
    <deleteFile :deleteVisible="isShow" @deleteCancel="closeWindow" @handleOk="confirmdDeletion" :content="$t('projectV2.deleteTest')"></deleteFile>

  </div>
</template>

<script>
import {
  queryJobData,
  queryTaskPage,
  getWorkReport,
} from "../../services/jobManagement";
import { deleteProject } from "../../services/myProjectApi";
import deleteFile from "../../components/layer/fileDialog/deleteFile";
import EditTest from "../../components/layer/studentJob/editTest";
import DistributionDialog from "../../components/layer/studentJob/distributionDialog";

export default {
  name: "CatWebPcIndex",
  components: {
    EditTest,
    deleteFile,
    DistributionDialog,
  },
  data() {
    return {
      testLimitTime: "",
      isShow: false,
      dialogVisible: true,
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      pageDto: {
        filter: {
          userId: "",
          company_code: "",
          platformType: "",
          name: "",
          langDesc: "",
          finish: null,
          code: "",
          sourceType: 1,
        },
        page: 1,
        rows: 10,
        sort: {},
      },
      tableData: [],
      delId: null,
      downTableData: [],
      downTableData2: [],
      fileName: "测试报告",
    };
  },
  created() {
    this.pageDto.page = 1;
    this.queryJob(this.pageDto.page, { create_time: "desc" });
  },
  destroyed() {
    window.sessionStorage.removeItem("myCurrentPageTest");
  },
  mounted() { },

  methods: {
    //列表排序
    sortChange({ column, prop, order }) {
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      }
      if (order === null) {
        this.queryJob(this.pageDto.page, { create_time: "desc" });
        return;
      }
      switch (prop) {
        case "createTime":
          this.pageDto.sort = { create_time: order };
          this.queryJob(this.pageDto.page, {
            create_time: order,
          });
          break;
        case "limitTime":
          this.pageDto.sort = { delivery_time: order };
          this.queryJob(this.pageDto.page, {
            delivery_time: order,
          });
          break;
        default:
          break;
      }
    },
    //表头样式

    async queryJob(page, sort) {
      this.pageDto.filter.companyCode = localStorage.myCompanyCode;
      this.pageDto.filter.platformType = this.$platformType;
      this.pageDto.filter.sourceType = 2; //2为查看测试
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.pageDto.filter.userId = userInfo.id;
      this.pageDto.page = page;
      this.pageDto.sort = sort;
      const { list, totalPage, totalRows, success } = await queryJobData(
        this.pageDto
      );
      if (!success) return;
      list.forEach((item) => {
        if (!item.finishTaskNumber) {
          item.finishTaskNumber = 0;
        } else if (!item.unFinishTaskNumber) {
          item.unFinishTaskNumber = 0;
        }
        item["totalTaskNumber"] =
          item.unFinishTaskNumber + item.finishTaskNumber;
      });
      this.tableData = list;
      this.tableDataInfo.totalPage = totalPage;
      this.tableDataInfo.totalRows = totalRows;
    },
    // 序号格式化
    getIndex($index) {
      (this.pageDto.page - 1) * this.pageDto.rows + $index + 1;
      if ($index < 9) {
        return "0" + ($index + 1);
      } else {
        return $index + 1;
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.pageDto.page = val;
      sessionStorage.setItem("myCurrentPageTest", val);
      this.queryJob(val, this.pageDto.sort);
    },
    handleSizeChange(val) {
      this.pageDto.rows = val;
      this.queryJob(this.pageDto.page, this.pageDto.sort);
    },
    // 创建作业
    createJob() {
      this.$router.push({ name: "createTest" });
    },
    // 查看详情
    checkJob(row) {
      this.$router.push({
        name: "testDetails",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            id: row.projectId,
            test: 2,
            companyCode: row.companyCode,
          })),
        },
      });
    },
    // 编辑
    editJob(row) {
      let params = {
        id: row.projectId,
        dialogVisible: this.dialogVisible,
        unFinishTaskNumber: row.unFinishTaskNumber,
        finishTaskNumber: row.finishTaskNumber,
        page: this.pageDto.page,
      };
      this.bus.$emit("params", params);
    },
    // 分配
    distribution(row) {
      this.testLimitTime = row.limitTime
      let busParams = {
        dialogVisible: this.dialogVisible,
        id: row.id,
        limitTime: row.limitTime,
        page: this.pageDto.page,
      };
      this.bus.$emit("busParams", busParams);
    },
    // 导出报告
    reporte(row) {
      getWorkReport({ id: row.id }).then(
        ({ result, status, success, errorDesc }) => {
          if (success && status == 200) {
            window.location.href = result;
          } else {
            this.$message.closeAll();
            this.$message.error(errorDesc);
            return;
          }
        }
      );
    },
    // 获取生成导出报告数据
    generateReporte(row) {
      let params = {
        filter: {
          fileId: row.id,
          projectId: row.projectId,
          companyCode: localStorage.myCompanyCode,
        },
      };
      queryTaskPage(params).then(({ list }) => {
        let obj = {};
        list = list.reduce((cur, next) => {
          obj[next.userId] ? "" : (obj[next.userId] = true && cur.push(next));
          return cur;
        }, []);
        const completeAdd = [];
        list.forEach((item, index) => {
          if (item.finish === 0) {
            completeAdd.push({
              ranking: index + 1,
              userName: item.userName ? item.userName : "",
              createTime: item.createTime ? item.createTime : "",
              finishTime: item.finishTime ? item.finishTime : "",
            });
          }
        });
        const inCompleteAdd = [];
        list.forEach((item, index) => {
          if (item.finish === 1) {
            inCompleteAdd.push({
              ranking: index + 1,
              userName: item.userName ? item.userName : "",
              createTime: item.createTime ? item.createTime : "",
              finishTime: item.finishTime ? item.finishTime : "",
            });
          }
        });
        this.downTableData = completeAdd; //未完成的学生名单
        this.downTableData2 = inCompleteAdd; //完成的学生名单
        let str = `<tr><td>${this.$t(
          "jobManagementV2.ranking"
        )}</td><td>${this.$t("jobManagementV2.studentName")}</td><td>${this.$t(
          "jobManagementV2.finishTime"
        )}</td><td>${this.$t("jobManagementV2.translationTime")}</td></tr>`;
        // 循环遍历，每行加入tr标签，每个单元格加td标签
        for (let i = 0; i < this.downTableData.length; i++) {
          str += "<tr>";
          for (const key in this.downTableData[i]) {
            // 增加\t为了不让表格显示科学计数法或者其他格式
            str += `<td>${this.downTableData[i][key] + "\t"}</td>`;
          }
          str += "</tr>";
        }
        let str2 = `<tr><td>${this.$t(
          "jobManagementV2.ranking"
        )}</td><td>${this.$t("jobManagementV2.studentName")}</td><td>${this.$t(
          "jobManagementV2.finishTime"
        )}</td><td>${this.$t("jobManagementV2.translationTime")}</td></tr>`;
        for (let i = 0; i < this.downTableData2.length; i++) {
          str += "<tr>";
          for (const key in this.downTableData2[i]) {
            // 增加\t为了不让表格显示科学计数法或者其他格式
            str += `<td>${this.downTableData2[i][key] + "\t"}</td>`;
          }
          str += "</tr>";
        }
        // Worksheet名
        const worksheet = "sheet";
        const url = "data:application/msword;base64,";
        // 下载的表格模板数据
        const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body>
        <p>${this.$t("jobManagementV2.jobName")}：${row.name}</p>
        <p>${this.$t("jobManagementV2.reportTime")}：${new Date().toLocaleString("cn", {
          hour12: false,
        })}</p>
        <p>${this.$t("projectV2.langDesc")}：${row.langDesc}</p>
        <p>${this.$t("projectV2.domain")}：${row.domainName}</p>
        <p>${this.$t("jobManagementV2.wordNumber")}：${row.sourceWordNum}</p>
        <p>${this.$t("jobManagementV2.sentenceNumber")}：${row.sentCount}</p>
        <p>${this.$t("projectV2.creator")}：${row.creatorName}</p>
        <p>${this.$t("projectV2.createTime")}：${row.createTime}</p>
        <p>${this.$t("jobManagementV2.startTime")}：${row.startTime}</p>
        <p>${this.$t("projectV2.limitTime")}：${row.limitTime}</p>
        <p>${this.$t("jobManagementV2.finishStudentList")}</p>
        <table border='1'>${str2}</table>
        <p>${this.$t("jobManagementV2.unFinishStudentList")}</p>
        <table border='1'>${str}</table>
        </body></html>`;
        // 输出base64编码
        const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));
        //导入文件命名
        var link = document.createElement("a");
        link.download = this.fileName;
        // 下载模板
        link.href = url + base64(template);
        link.click();
      });
    },
    // 删除
    openDelDialog(row) {
      this.isShow = true;
      this.delId = row.projectId;
    },
    confirmdDeletion() {
      deleteProject({ id: this.delId })
        .then(() => {
          this.$message.closeAll();
          this.$message.success(this.$t("projectV2.success"));
          if (this.pageDto.page > 1 && this.tableData.length <= 1) {
            this.pageDto.page--;
          }
          this.queryJob(this.pageDto.page, this.pageDto.sort);
          this.isShow = false;
        })
        .catch(() => {
          this.$message.closeAll();
          this.$message.warning(this.$t("projectV2.error"));
          this.isShow = false;
        });
    },
    closeWindow() {
      this.isShow = false;
    },
    closeDialog() {
      this.delId = null;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
